import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { officeApi } from "../../api/config";
import Emty from "../../components/Emty/Emty";
import { PaymentCard } from "../../interface/interface";
import { makeComma } from "../../lib/lib";
import "./css/index.css";

function Payment() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [type, settype] = useState<string | undefined>(undefined);
  const [data, setData] = useState<PaymentCard[]>([]);
  const [search, setsearch] = useState<string>("");

  const __nav = useCallback(
    (id: PaymentCard) => {
      navigate(`/payment/list`, {
        state: id,
      });
    },
    [navigate]
  );
  const onSearch = useCallback(() => {
    officeApi
      .get(
        `/web/cstm/prjtPaym?prjt_nm=${search}${
          type ? `&prjt_type_cd=${type}` : ""
        }`
      )
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setData(succ_obj);
        }
      });
  }, [search, type]);

  useEffect(() => {
    officeApi
      .get(`/web/cstm/prjtPaym${type ? `?prjt_type_cd=${type}` : ""}`)
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setData(succ_obj);
        }
      });
    return () => {};
  }, [type]);

  return (
    <main className="project">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>프로젝트별 결제현황</p>
          </div>
          <div className="right">
            <div className="type-box-wrapper">
              <div className={`type_box ${isOpen ? "open" : ""}`}>
                <button
                  className="now"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <div className="type">
                    {type
                      ? type === "prjt"
                        ? "팀 프로젝트"
                        : "팀 밋업"
                      : "유형 전체"}
                  </div>
                  <img
                    className="buttontype"
                    src="/assets/common/button.svg"
                  ></img>
                </button>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    settype(undefined);
                  }}
                >
                  유현전체
                </button>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    settype("prjt");
                  }}
                >
                  팀 프로젝트
                </button>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    settype("mtup");
                  }}
                >
                  팀 밋업
                </button>
              </div>
            </div>
            <form
              className="search_box"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <input
                type="text"
                className="type2"
                placeholder="프로젝트 검색"
                onChange={(e) => {
                  setsearch(e.target.value);
                }}
              ></input>
              <img className="search" src="./assets/common/search.svg"></img>
            </form>
            <div className="button" onClick={onSearch}>
              검색
            </div>
          </div>
        </div>

        <div className="sub">
          <div className="left">
            <div className="name1">유형</div>
            <div className="name2">프로젝트명</div>
          </div>
          <div className="right">
            <ul className="menu">
              <li>결제성공</li>
              <li>결제취소</li>
              <li>결제실패</li>
              <li>총결제금액</li>
            </ul>
          </div>
        </div>
        <div className="list">
          {data.length == 0 ? <Emty /> : null}
          {data.map((item, index) => {
            return (
              <div key={index} className={`box ${item.prjt_type_cd}`}>
                <div className="type">
                  {item.prjt_type_cd === "prjt" ? "팀프로젝트" : "팀 밋업"}
                </div>
                <div className="name">{item.prjt_nm}</div>
                <div className="success">
                  {item.paym_succ_cnt ? item.paym_succ_cnt : 0}건
                </div>
                <div className="cancel">{item.paym_can_cnt}건</div>
                <div className="fail">{item.paym_ret_cnt}건</div>
                <div className="totalpay">{makeComma(item.paym_succ_amt)}</div>
                <button
                  className="nav-btn"
                  onClick={() => {
                    __nav(item);
                  }}
                >
                  결제리스트
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}

export default Payment;
